import { useState } from "react";
import { toast } from "sonner";
import { Plus, Save, Trash2, Pencil, X } from "lucide-react";
import { createShiftTemplate, updateShiftTemplate, deleteShiftTemplate } from "../../../lib/teamsSchedule";

export const fmtHHMM = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

const Row = ({ init, onSave, onCancel, testid }) => {
  const [d, setD] = useState(init);
  const cls = "input-swiss px-2 py-1 rounded-sm text-[12px]";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <input className={`${cls} w-36`} placeholder="Name (e.g. Opening)" value={d.name} onChange={(e) => setD({ ...d, name: e.target.value })} data-testid={`${testid}-name`} />
      <input type="time" className={cls} value={d.start} onChange={(e) => setD({ ...d, start: e.target.value })} data-testid={`${testid}-start`} />
      <span className="text-xs">to</span>
      <input type="time" className={cls} value={d.end} onChange={(e) => setD({ ...d, end: e.target.value })} data-testid={`${testid}-end`} />
      <button onClick={() => onSave(d)} className="btn-primary px-2 py-1 rounded-sm text-[11px] font-bold flex items-center gap-1" data-testid={`${testid}-save`}><Save size={12} /> Save</button>
      <button onClick={onCancel} className="p-1 rounded-sm border border-[color:var(--ups-border)]" data-testid={`${testid}-cancel`}><X size={12} /></button>
    </div>
  );
};

export const ShiftTemplatesPanel = ({ templates, reload }) => {
  const [editId, setEditId] = useState(null);
  const run = async (fn, msg) => {
    try { await fn(); toast.success(msg); setEditId(null); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="card-swiss rounded-sm p-3 space-y-2" data-testid="shift-templates-panel">
      <div className="flex items-center justify-between">
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[color:var(--ups-subtext)]">Saved shifts (all stores)</div>
        {editId !== "new" && (
          <button onClick={() => setEditId("new")} className="text-[11px] px-2 py-1 rounded-sm border border-[color:var(--ups-border)] flex items-center gap-1" data-testid="shift-template-add-btn"><Plus size={12} /> Add</button>
        )}
      </div>
      {templates.map((t) => editId === t.id ? (
        <Row key={t.id} init={t} testid={`shift-template-edit-${t.id}`} onCancel={() => setEditId(null)}
          onSave={(d) => run(() => updateShiftTemplate(t.id, { name: d.name, start: d.start, end: d.end }), "Saved shift updated")} />
      ) : (
        <div key={t.id} className="flex items-center gap-3 text-sm" data-testid={`shift-template-${t.id}`}>
          <span className="font-semibold w-36">{t.name}</span>
          <span className="font-mono text-xs">{fmtHHMM(t.start)} – {fmtHHMM(t.end)}</span>
          <button onClick={() => setEditId(t.id)} className="p-1 rounded-sm hover:bg-[color:var(--ups-muted)]" data-testid={`shift-template-edit-btn-${t.id}`}><Pencil size={12} /></button>
          <button onClick={() => window.confirm(`Delete "${t.name}"?`) && run(() => deleteShiftTemplate(t.id), "Deleted")}
            className="p-1 rounded-sm hover:bg-red-50 text-red-600" data-testid={`shift-template-delete-${t.id}`}><Trash2 size={12} /></button>
        </div>
      ))}
      {editId === "new" && (
        <Row init={{ name: "", start: "09:00", end: "17:00" }} testid="shift-template-new" onCancel={() => setEditId(null)}
          onSave={(d) => run(() => createShiftTemplate(d), "Saved shift added")} />
      )}
      {templates.length === 0 && editId !== "new" && <div className="text-xs text-[color:var(--ups-subtext)]">No saved shifts yet.</div>}
    </div>
  );
};
